import { render } from "./TrainingList.vue?vue&type=template&id=3a56834e&ts=true"
import script from "./TrainingList.vue?vue&type=script&lang=ts"
export * from "./TrainingList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__